import React from 'react';
import {
    Box,
    Typography,
    Button,
    Card,
    CardContent,
} from '@mui/material';
import {
    CheckCircle as CheckIcon,
} from '@mui/icons-material';

const StepSuccess = ({ customerData, onClose }) => {
    return (
        <Box sx={{ textAlign: 'center' }}>
            {/* Success Icon */}
            <Box sx={{ mb: 3 }}>
                <CheckIcon
                    sx={{
                        fontSize: 80,
                        color: 'success.main',
                    }}
                />
            </Box>

            <Typography variant="h5" gutterBottom color="success.main" fontWeight={600}>
                Đăng Ký Thành Công!
            </Typography>

            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                Chúc mừng bạn đã trở thành khách hàng ưu đãi
            </Typography>

            {/* Customer Information Card */}
            {customerData && (
                <Card sx={{ mb: 3, textAlign: 'left' }}>
                    <CardContent>
                        <Typography variant="h6" gutterBottom color="primary">
                            Thông Tin Khách Hàng
                        </Typography>

                        <Box sx={{ mt: 2 }}>
                            <Box sx={{ mb: 2 }}>
                                <Typography variant="body2" color="text.secondary">
                                    Mã khách hàng:
                                </Typography>
                                <Typography variant="body1" fontWeight={600}>
                                    {customerData.code}
                                </Typography>
                            </Box>

                            <Box sx={{ mb: 2 }}>
                                <Typography variant="body2" color="text.secondary">
                                    Họ và tên:
                                </Typography>
                                <Typography variant="body1" fontWeight={600}>
                                    {customerData.fullName}
                                </Typography>
                            </Box>

                            <Box sx={{ mb: 2 }}>
                                <Typography variant="body2" color="text.secondary">
                                    Email:
                                </Typography>
                                <Typography variant="body1" fontWeight={600}>
                                    {customerData.email}
                                </Typography>
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            )}

            {/* Benefits Section */}
            <Card sx={{ mb: 3, bgcolor: 'primary.light', color: 'white' }}>
                <CardContent>
                    <Typography variant="h6" gutterBottom fontWeight={600}>
                        Quyền Lợi Của Bạn
                    </Typography>
                    <Box sx={{ textAlign: 'left', mt: 2 }}>
                        <Typography variant="body2" sx={{ mb: 1 }}>
                            ✓ Giảm giá đặc biệt cho khách hàng ưu đãi
                        </Typography>
                        <Typography variant="body2" sx={{ mb: 1 }}>
                            ✓ Ưu tiên phục vụ
                        </Typography>
                        <Typography variant="body2">
                            ✓ Tích điểm và nhận quà tặng
                        </Typography>
                    </Box>
                </CardContent>
            </Card>

            {/* Email Confirmation Notice */}
            <Box
                sx={{
                    p: 2,
                    bgcolor: 'info.light',
                    borderRadius: 1,
                    mb: 3,
                }}
            >
                <Typography variant="body2" color="info.dark">
                    📧 Email xác nhận đã được gửi đến hộp thư của bạn
                </Typography>
            </Box>

            {/* Close Button */}
            {onClose && (
                <Button
                    fullWidth
                    variant="contained"
                    size="large"
                    onClick={onClose}
                >
                    Hoàn Tất
                </Button>
            )}
        </Box>
    );
};

export default StepSuccess;
